<div class="container">

    <!-- Loading -->
    <div class="card" *ngIf="loading">
        <p>Loading subscriber list...</p>
    </div>

    <!-- Error -->
    <div class="card error" *ngIf="error">
        {{ error }}
    </div>

    <!-- DESKTOP TABLE -->
    <div class="card d-none d-md-block" *ngIf="!loading && !error && vouchers.length">

        <h1 class="title">वर्गणी विभाग, सा. विवेक</h1>
        <!-- <h2 class="title">वर्गणीदार नूतनीकरण यादी ({{ monthYear }})</h2> -->
        <h4 class="text-center">प्रतिनिधीचे नाव : {{ rep_name }}</h4>
        <h5 class="count-title">
            एकूण वर्गणीदारांची संख्या: {{ vouchers.length }}
        </h5>

        <div class="table-responsive">
            <table class="table table-sm subscriber-table">
                <thead>
                    <tr>
                        <th>अ.क्रमांक</th>
                        <th>वर्गणीदारचे नाव</th>
                        <th>वर्गणीदार क्रमांक</th>
                        <th>पत्ता</th>
                        <th>वितरण प्रकार</th>
                        <th>पावतीचा प्रकार</th>
                        <th>वैध दिनांक</th>
                        <th>वितरण दिनांक</th>
                        <th>वितरण पद्धत</th>
                        <th>वितरण प्रतिनिधी</th>
                        <th>वैध दिनांक1</th>
                        <th>वितरण दिनांक1</th>
                        <th>वितरण पद्धत1</th>
                        <th>वितरण प्रतिनिधी</th>
                        <th>मोबाईल नंबर</th>
                        <th>पावतीची रक्कम</th>

                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let vou of vouchers; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ vou.name }}</td>
                        <td>{{ vou.sub_no }}</td>
                        <!-- <td>{{ vou.address }} {{ vou.taluka }} {{ vou.district }} {{ vou.pincode }} {{ vou.state }} {{ vou.country }}</td> -->
                        <td>
                            {{ vou.address }},
                            {{ vou.taluka }},
                            {{ vou.district }},
                            {{ vou.pincode }},
                            {{ vou.state }},
                            {{ vou.country }}
                        </td>
                        <td>{{ vou.subtype }}</td>
                        <td>{{ vou.rcpt_type }}</td>
                        <!-- <td>
                            {{ vou.start_period | date:'dd/MM/yyyy' }} -
                            {{ vou.end_period | date:'dd/MM/yyyy' }}
                        </td> -->
                        <td>
                            <span *ngIf="vou.start_period">
                                {{ vou.start_period | date:'dd/MM/yyyy' }}
                            </span>
                            -
                            <span *ngIf="vou.end_period">
                                {{ vou.end_period | date:'dd/MM/yyyy' }}
                            </span>
                        </td>
                        <td>{{ vou.dispatch_date }}</td>
                        <td>{{ vou.delivery_mode }}</td>
                        <td>{{ vou.distribution_rep }}</td>
                        <!-- Second Durstion -->
                        <!-- <td>
                            <span *ngIf="vou.start_period1">
                                {{ vou.start_period1 | date:'dd/MM/yyyy' }}
                            </span>
                            -
                            <span *ngIf="vou.end_period1">
                                {{ vou.end_period1 | date:'dd/MM/yyyy' }}
                            </span>
                        </td> -->
                        <td>
                            <ng-container *ngIf="vou.start_period1 && vou.start_period1 != '0000-00-00'; else emptyDate">
                                {{ vou.start_period1 | date:'dd/MM/yyyy' }} -
                                {{ vou.end_period1 | date:'dd/MM/yyyy' }}
                            </ng-container>
                        
                            <ng-template #emptyDate>
                                &nbsp;
                            </ng-template>
                        </td>

                        <!-- <td>{{ vou.dispatch_date1 }}</td> -->
                        <td>
                            <ng-container *ngIf="vou.start_period1 && vou.start_period1 != '0000-00-00'; else emptyDate">
                                {{ vou.dispatch_date1 | date:'dd/MM/yyyy' }}
                            </ng-container>
                        
                            <ng-template #emptyDate>
                                &nbsp;
                            </ng-template>
                        </td>

                        <!-- <td>{{ vou.delivery_mode1 }}</td> -->
                        <td>
                            <ng-container *ngIf="vou.start_period1 && vou.start_period1 != '0000-00-00'; else emptyMode">
                                {{ vou.delivery_mode1 }}
                            </ng-container>

                            <ng-template #emptyMode>
                                &nbsp;
                            </ng-template>
                        </td>

                        <!-- <td>{{ vou.distribution_rep }}</td> -->
                        <td>
                            <ng-container *ngIf="vou.start_period1 && vou.start_period1 != '0000-00-00'; else emptyRep">
                                {{ vou.distribution_rep }}
                            </ng-container>

                            <ng-template #emptyRep>
                                &nbsp;
                            </ng-template>
                        </td>

                        <td>{{ vou.mobileNumber }}</td>
                        <td>{{ vou.select_entry_amt }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="text-center mb-3">
            <p><b>-: Payment Link :-</b></p>
            <p> https://www.evivek.com/subscriber-growth-campaign-2026/</p> 
            <p>
                <a href="https://www.evivek.com/subscriber-growth-campaign-2026/" target="_blank">
                    https://www.evivek.com/subscriber-growth-campaign-2026/
                </a>
            </p>
        </div> -->
    </div>

    <!-- MOBILE TABLE VIEW -->
    <div class="d-block d-md-none" *ngIf="!loading && !error && vouchers.length">

        <!-- PAGE HEADINGS -->
        <div class="text-center mb-3">
            <h1 class="title">वर्गणी विभाग, सा. विवेक</h1>
            <h2 class="title">प्रतिनिधीचे नाव: {{ rep_name }}</h2>

            <!-- <h3 class="count-title">
                वर्गणीदार नूतनीकरण यादी ({{ monthYear }})
            </h3> -->

            <h3 class="count-title">
                एकूण वर्गणीदारांची संख्या: {{ vouchers.length }}
            </h3>
        </div>

        <div class="table-responsive">
            <table class="table table-bordered table-sm mobile-table">
                <thead class="table-light">
                    <tr>
                        <th>अ.क्रमांक</th>
                        <th>वर्गणीदारचे नाव</th>
                        <th>वर्गणीदार क्रमांक</th>
                        <th>पत्ता</th>
                        <th>वितरण प्रकार</th>
                        <th>पावतीचा प्रकार</th>
                        <th>वैध दिनांक</th>
                        <th>वितरण दिनांक</th>
                        <th>वितरण पद्धत</th>
                        <th>वितरण प्रतिनिधी</th>
                        <th>वैध दिनांक1</th>
                        <th>वितरण दिनांक1</th>
                        <th>वितरण पद्धत1</th>
                        <th>वितरण प्रतिनिधी</th>
                        <th>मोबाईल नंबर</th>
                        <th>पावतीची रक्कम</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let vou of vouchers; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ vou.name }}</td>
                        <td>{{ vou.sub_no }}</td>
                        <!-- <td>{{ vou.address }} {{ vou.taluka }} {{ vou.district }} {{ vou.pincode }} {{ vou.state }} {{ vou.country }}</td> -->
                        <td>
                            {{ vou.address }},
                            {{ vou.taluka }},
                            {{ vou.district }},
                            {{ vou.pincode }},
                            {{ vou.state }},
                            {{ vou.country }}
                        </td>
                        <td>{{ vou.subtype }}</td>
                        <td>{{ vou.rcpt_type }}</td>
                        <!-- <td>
                            {{ vou.start_period | date:'dd/MM/yyyy' }} -
                            {{ vou.end_period | date:'dd/MM/yyyy' }}
                        </td> -->
                        <td>
                            <span *ngIf="vou.start_period">
                                {{ vou.start_period | date:'dd/MM/yyyy' }}
                            </span>
                            -
                            <span *ngIf="vou.end_period">
                                {{ vou.end_period | date:'dd/MM/yyyy' }}
                            </span>
                        </td>
                        <td>{{ vou.dispatch_date | date:'dd/MM/yyyy'}}</td>
                        <td>{{ vou.delivery_mode }}</td>
                        <td>{{ vou.distribution_rep }}</td>
                        <!-- <td>
                            <span *ngIf="vou.start_period1">
                                {{ vou.start_period1 | date:'dd/MM/yyyy' }}
                            </span>
                            -
                            <span *ngIf="vou.end_period1">
                                {{ vou.end_period1 | date:'dd/MM/yyyy' }}
                            </span>
                        </td> -->
                        <td>
                            <ng-container *ngIf="vou.start_period1 && vou.start_period1 != '0000-00-00'; else emptyDate">
                                {{ vou.start_period1 | date:'dd/MM/yyyy' }} -
                                {{ vou.end_period1 | date:'dd/MM/yyyy' }}
                            </ng-container>
                        
                            <ng-template #emptyDate>
                                &nbsp;
                            </ng-template>
                        </td>

                        <!-- <td>{{ vou.dispatch_date1 | date:'dd/MM/yyyy' }}</td> -->
                        <td>
                            <ng-container *ngIf="vou.start_period1 && vou.start_period1 != '0000-00-00'; else emptyDate">
                                {{ vou.dispatch_date1 | date:'dd/MM/yyyy' }}
                            </ng-container>
                        
                            <ng-template #emptyDate>
                                &nbsp;
                            </ng-template>
                        </td>

                        <!-- <td>{{ vou.delivery_mode1 }}</td> -->
                        <td>
                            <ng-container *ngIf="vou.start_period1 && vou.start_period1 != '0000-00-00'; else emptyMode">
                                {{ vou.delivery_mode1 }}
                            </ng-container>
                        
                            <ng-template #emptyMode>
                                &nbsp;
                            </ng-template>
                        </td>

                        <!-- <td>{{ vou.distribution_rep }}</td> -->
                        <td>
                            <ng-container *ngIf="vou.start_period1 && vou.start_period1 != '0000-00-00'; else emptyRep">
                                {{ vou.distribution_rep }}
                            </ng-container>
                        
                            <ng-template #emptyRep>
                                &nbsp;
                            </ng-template>
                        </td>

                        <td>{{ vou.mobileNumber }}</td>
                        <td>{{ vou.select_entry_amt }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- <div class="text-center mb-3">
            <p><b>-: Voucher Link :-</b></p>
            <p>https://www.evivek.com/subscriber-growth-campaign-2026/</p>
        </div> -->


    </div>

    <!-- NO DATA (Desktop + Mobile both) -->
    <div class="card" *ngIf="!loading && !error && !vouchers.length">
        <p>No vouchers found.</p>
    </div>

</div>